import { useState } from "react";
import { Sidebar } from "../../component/Sidebar/Sidebar";
import PMCSidebar from "../Pmc/PMCSidebar";
import { PmsLogo } from "../../component/logo/Logo";
import { GridDashBoard } from "../../style/Dashboard";
import { GridHeader, PharmacySidebar, PharmacyMainWraper } from "../../style/PMCStyle/PCMDashboard";
import PMCHeader from "./PMCHeader";
import "./Pmc.css"
// config/sidebarConfig.js
import EligiableImg from "../../assets/Pmc/Ads/Asset-21.png";
import Cal from "../../assets/sidebar/calendar.svg";
import User from "../../assets/sidebar/user.svg";
import Menu from "../../assets/sidebar/menu.svg";
import Person from "../../assets/sidebar/person.svg";
import CalA from "../../assets/sidebar/calendarA.svg";
import UserA from "../../assets/sidebar/userA.svg";
import MenuA from "../../assets/sidebar/menuA.svg";
import PersonA from "../../assets/sidebar/personA.svg";
import { Navbar } from "../../component/Navbar/Navbar";
import { GContainer, Heading, Seachbar, CustomBsSearch, Input } from "../../style/Navbar";
import { PMCContainer, CustomLink } from "../../style/PMCStyle/PMCTab";
import Router from '../../Routes'
import Photo from "../../assets/Pmc/johnImage.png";
import { ContainerWrapper, Image, H3, ADImage } from "../../style/PMCStyle/PCMDashboard";
import { useHistory } from "react-router-dom";
import { Grid } from "@material-ui/core";
export const sidebarConfig = [
  {
    path: "",
    icon: Cal,
    activeIcon: CalA,
    alt: "Cal",
  },
  {
    path: "/Pmc/dashboard",
    icon: User,
    activeIcon: UserA,
    alt: "User",
  },
  {
    path: "",
    icon: Menu,
    activeIcon: MenuA,
    alt: "Menu",
  },
  {
    path: "",
    icon: Person,
    activeIcon: PersonA,
    alt: "Person",
  },
];
export default function PharmacyManagementSystem() {
  const history = useHistory()
  let headerVisibility = false;
  if (history.location.pathname === "/Pmc/pricing" || history.location.pathname === "/Pmc/dispensed") {
    headerVisibility = true;
  } else {
    headerVisibility = false;
  }
  return (
    <>
      <GridHeader>
        <PharmacySidebar>
          <PmsLogo />
          <PMCSidebar config={sidebarConfig} />
        </PharmacySidebar>
        <PharmacyMainWraper>
          <div className="container">

            {/* navbar of PMC */}
            <div className="pmc-navbar-grid">
              <PMCHeader />
            </div>

            <ContainerWrapper>
              <Grid container>
                <Grid item lg={4} md={5} sm={12} xs={12}>
                  <Grid container className="responsiveHeader" >
                    <Image src={Photo} alt="photo" />
                    <div style={{ marginLeft: "0px" }}>
                      <H3>
                        <span style={{ color: "#4678ED", fontSize: "22px", fontWeight: "700" }}>Pharmacist John Smith</span>{" "}
                      </H3>
                      <H3 style={{ color: "#58595B", fontSize: "22px", fontWeight: "700" }}>ID : 123456</H3>
                    </div>
                  </Grid>
                </Grid>
                <Grid item lg={8} md={7} sm={12} xs={12} className="responsiveImage">
                  {headerVisibility && <img src={EligiableImg} />}
                </Grid>
              </Grid>
            </ContainerWrapper>
            <PMCContainer>
              <CustomLink
                activeClassName="TabActive"
                to="/Pmc/dashboard"
              >
                Dashboard
              </CustomLink>
              <CustomLink
                activeClassName="TabActive"
                to="/Pmc/pendingrx"
              >
                Pending Rx
              </CustomLink>
              <CustomLink
                activeClassName="TabActive"
                to="/Pmc/rxdocs"
                onClick={e => e.preventDefault()}
              >
                RxDocs
              </CustomLink>
              <CustomLink
                activeClassName="TabActive"
                to="/Pmc/pricing"
              >
                Pricing
              </CustomLink>
              <CustomLink
                activeClassName="TabActive"
                to="/Pmc/dispensed"
                onClick={e => e.preventDefault()}
              >
                Dispensed
              </CustomLink>

            </PMCContainer>
            <div>
              <Router />

            </div>

          </div>
        </PharmacyMainWraper >

      </GridHeader >
    </>
  )
}